import React, { useEffect } from 'react'

import * as S from './styled'

interface props {
    id: string
    label?: string
    onChange?: (b: boolean) => void
    value?: boolean
    disabled?: boolean
    optionalFunctionTrigger?: () => void
}

export const SwitchButtonWithTrigger: React.FC<props> = ({
    label,
    id,
    onChange,
    value,
    disabled,
    optionalFunctionTrigger
}) => {
    const [check, setCheck] = React.useState<boolean>(value ?? false)
    useEffect(() => {
        setCheck(value ?? false)
    }, [value])

    const handleOnChange = (): void => {
        const newState = !check
        setCheck(newState)
        onChange && onChange(newState)
        optionalFunctionTrigger()
    }

    return (
        <S.SwitchButton>
            <S.CheckBoxWrapper>
                <S.CheckBox id={id} type="checkbox" onChange={handleOnChange} disabled={disabled} checked={check} />
                <S.CheckBoxLabel htmlFor={id} />
            </S.CheckBoxWrapper>
            {label && <S.SwitchLabel>{label}</S.SwitchLabel>}
        </S.SwitchButton>
    )
}
